'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var runner = require('@pixi/runner');

class TransformFeedback {
  constructor() {
    this._glTransformFeedbacks = {};
    this.buffers = [];
    this.disposeRunner = new runner.Runner("disposeTransformFeedback");
  }
  bindBuffer(index, buffer) {
    this.buffers[index] = buffer;
  }
  destroy() {
    this.disposeRunner.emit(this, false);
  }
}

exports.TransformFeedback = TransformFeedback;
//# sourceMappingURL=TransformFeedback.js.map
